export default __webpack_public_path__ + "images/XL.9ba9050.png";